export const filter_config = () => ({
  title: 'Neuron filters',
  filters: [
    {
      label: 'Status',
      key: 'status',
      value: [
        { label: 'Active', value: 'active' },
        { label: 'Inactive', value: 'inactive' }
      ],
      type: 'multichoice'
    },
    { value: 'created_on', label: 'Date created', key: 'created_on', type: 'range' }
  ]
});
